import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { X } from "lucide-react";
import { toast } from "sonner";

export function ChangePasswordModal({ onClose }) {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (newPassword.length < 6) {
            toast.error("New password must be at least 6 characters");
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error("New passwords do not match");
            return;
        }
        setSaving(true);
        try {
            await api.post("/auth/change-password", {
                current_password: currentPassword,
                new_password: newPassword,
            });
            toast.success("Password updated");
            onClose();
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Could not update password");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
            <div className="bg-white border-2 border-[#111111] w-full max-w-sm animate-slide-up">
                <div className="flex justify-between items-center px-6 py-4 border-b-2 border-[#111111]">
                    <h3 className="font-display text-2xl">Change Password</h3>
                    <button onClick={onClose} data-testid="close-change-password" className="p-1 hover:bg-[#F8F9FA]">
                        <X size={20} />
                    </button>
                </div>
                <form onSubmit={submit} className="p-6 space-y-4">
                    <div>
                        <label className="label-caps block mb-2">Current Password</label>
                        <input
                            type="password"
                            required
                            data-testid="current-password-input"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            className="w-full bg-[#F8F9FA] border border-[#E5E5E5] px-4 py-2 focus:border-[#111111] outline-none"
                        />
                    </div>
                    <div>
                        <label className="label-caps block mb-2">New Password</label>
                        <input
                            type="password"
                            required
                            data-testid="new-password-input"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="w-full bg-[#F8F9FA] border border-[#E5E5E5] px-4 py-2 focus:border-[#111111] outline-none"
                        />
                    </div>
                    <div>
                        <label className="label-caps block mb-2">Confirm New Password</label>
                        <input
                            type="password"
                            required
                            data-testid="confirm-password-input"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="w-full bg-[#F8F9FA] border border-[#E5E5E5] px-4 py-2 focus:border-[#111111] outline-none"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={saving}
                        data-testid="change-password-submit"
                        className="w-full bg-[#FF3B30] text-white font-bold py-3 hover:bg-[#D70015] disabled:opacity-60"
                    >
                        {saving ? "Updating…" : "Update Password"}
                    </button>
                </form>
            </div>
        </div>
    );
}
